import * as React from 'react';

import {EmptyStateLarge} from 'shells/empty-states/empty-state-large';

import {PageTitleBar, PageContainer} from '../../layout';
import {PageWrapper} from '../../layout/page-wrapper';

export const NoAccessPage = () => {
    return (
        <PageWrapper>
            <PageContainer
                title='Nutshell Campaigns'
                pageTitleBar={
                    <PageTitleBar
                        title='Nutshell Campaigns'
                        subheaderPrimaryText='Send beautifully designed messages to thousands of contacts at once'
                    />
                }
                darkBackground={true}
                noPadding={true}
            >
                <div className='full-width full-height background-white'>
                    <EmptyStateLarge
                        title='Nutshell Campaigns'
                        subtitle='Ask your account admin for access to start using these features'
                        detailTextBullets={[
                            'Send beautifully designed messages to thousands of contacts at once',
                            'Write and design messages with the drag-and-drop editor — or get a quick start with one of our templates!',
                            'View message engagement metrics and newsletter performance over time',
                        ]}
                        icon={
                            <img
                                alt=''
                                style={{width: 278}}
                                src='/include/images/empty-states/parachuting-envelopes.svg'
                            />
                        }
                    />
                </div>
            </PageContainer>
        </PageWrapper>
    );
};
